// extracted by mini-css-extract-plugin
module.exports = {"newContactsTable":"newContactsTable_newContactsTable__SHpjN"};